/*eslint-disable */

import Notes from "@/components/private/workspace/notes/";
import briefcase from "@/components/private/workspace/briefcase/";
import { bus } from '@/main';
import chatUserList from "@/components/private/workspace/chat-user-list/";
import responsiveMixin from '@/mixins/responsive';
import schedulerData from "@/components/private/workspace/schedulerData/";
import toDoAppPopup from "@/components/private/workspace/todo-app/";

const $ = window.jQuery = require('jquery');
export default {
  name: 'workspace',
  mixins: [responsiveMixin],
  components: {
    'notes': Notes,
    'briefcase': briefcase,
    'scheduler-data': schedulerData,
    'todo-app': toDoAppPopup,
    'chat-user-list': chatUserList
  },
  props: [],
  data() {
    return {
      notesTabEnabled: 'notes',
      chatRoomInfo: null,
      selfUserId: '',
    }
  },
  computed: {
  },
  mounted() {
    this.selfUserId = localStorage.getItem('LoginedUserID');
    bus.$emit('clearMessageNotifications', {});
  },
  methods: {
    mblToolbarDisbledMethod(){
      const frame = document.getElementById('frame');
      if (frame) {
        frame.classList.remove('acvt_toolbar');
      }
    },
    collapseWorkspaceFun() {

      const frame = document.getElementById('frame');
      frame.classList.toggle('collapsed_chat_list');

      const slideLeftArrow = document.querySelector('.slide_left_arrow');
      slideLeftArrow.classList.toggle('active');

      const wrapMetaName = document.querySelector('.wrap .meta .name');
      if (wrapMetaName.classList.contains('active')) {
        setTimeout(() => {
          wrapMetaName.classList.remove('active');
        }, 500);
      } else {
        wrapMetaName.classList.add('active');
      }

      const searchElement = document.getElementById('search');
      if (searchElement.classList.contains('active')) {
        // Assuming 'bus' is a global event bus or accessible in this scope.
        // If 'bus' is not defined, this line will cause an error.
        if (typeof bus !== 'undefined' && bus && typeof bus.$emit === 'function') {
          bus.$emit('collapseActvToggleStateBus', false);
        }
        setTimeout(() => {
          searchElement.classList.remove('active');
        }, 500);
      } else {
        // Assuming 'bus' is a global event bus or accessible in this scope.
        if (typeof bus !== 'undefined' && bus && typeof bus.$emit === 'function') {
          bus.$emit('collapseActvToggleStateBus', true);
        }
        searchElement.classList.add('active');
      }
    },
    todoTabChangedMethod(tabName) {
      this.notesTabEnabled = tabName;
    },
  },
  watch: {
  },
  beforeCreate: function () {
    document.body.classList.add('workspace_main_page_wrp');
  },
  beforeRouteLeave(to, from, next) {
    document.body.classList.remove('workspace_main_page_wrp');
    setTimeout(() => {
      bus.$emit('workspaceRouterLeaveEvntBus', 'Router_leave')
    }, 100)
    next();
  },
}